import { render, staticRenderFns } from "./BaseCurrencyInput.vue?vue&type=template&id=ff7470b4&scoped=true"
import script from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
export * from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./BaseCurrencyInput.vue?vue&type=style&index=0&id=ff7470b4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7470b4",
  null
  
)

export default component.exports